const variableValidation = (
    errors,
    values,
    isValidVariableName,
    checkUniqueVariableName,
    unsavedVariables,
    fieldName = 'variable'
) => {
    if (!values) return;
    if (values[fieldName]) {
        if (!isValidVariableName(values[fieldName])) {
            errors = {
                ...errors,
                variable: 'Must start with letter followed by letters, numbers, or underscores',
            };
        } else if (!checkUniqueVariableName(values[fieldName], `${values.id}`)) {
            errors = {
                ...errors,
                [fieldName]: 'Must be unique in procedure',
            };
        } else {
            let isNotUnique = unsavedVariables.find((vr) => vr.name === values[fieldName] && vr.id !== values.id);
            if (!isNotUnique && fieldName !== 'variable') {
                isNotUnique = values.variable === values[fieldName];
            }
            if (isNotUnique) {
                errors = {
                    ...errors,
                    [fieldName]: 'Must be unique in procedure',
                };
            }
        }
    } else {
        errors = { ...errors, [fieldName]: 'Required' };
    }
    if (!values.label) {
        errors = { ...errors, label: 'Required' };
    }
    return errors;
};

const selectFieldValidation = (errors, values) => {
    if (!values.options || values.options?.length <= 0) {
        errors = {
            ...errors,
            options: 'Required',
        };
    } else {
        values?.options.map((option, idx) => {
            if (!option.label) {
                errors = {
                    ...errors,
                    [`options[${idx}].label`]: 'Required',
                };
            }
            if (!option.value) {
                errors = {
                    ...errors,
                    [`options[${idx}].value`]: 'Required',
                };
            }
        });
    }
    return errors;
};

export { variableValidation, selectFieldValidation };
